import Vue from 'vue';

export default {
  namespaced: true,
  state: () => ({
  }),
  getters: {

  },
  mutations: {

  },
  actions: {
    async listenerModificadores({commit,rootGetters}){
      let last = await Vue.prototype.$dbHandler.getLastRecord("PDV_Modificadores","Upat");
      const firestore  = rootGetters.getFirebaseApp.firestore;
      const collection  = firestore.collection("PDV_ModificadoresProducto");
      const query       = firestore.query(
        collection,
        firestore.where("Upat", ">=", ((last)?last.value.Upat:0)),
        firestore.where("Tenant", "==", rootGetters.getFirebaseApp.tenant)
      );
      const unsuscribe =  firestore.onSnapshot(query,(snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const element = change.doc.data();
          if (change.type === "added") {
            commit(
              "dataLists/setArrayItem",
              {
                id: change.doc.id,
                list: "PDV_Modificadores",
                element
              },
              { root: true }
            );
          } else if (change.type === "modified") {
            commit(
              "dataLists/setArrayItem",
              {
                id: change.doc.id,
                list: "PDV_Modificadores",
                element
              },
              { root: true }
            );
          } else if (change.type === "removed") {
            commit(
              "dataLists/unsetArrayItem",
              {
                id: change.doc.id,
                list: "PDV_Modificadores"
              },
              { root: true }
            );
          }
        });
      });
    },
  }
}